import styled from "styled-components";

export const SpinnerContainer = styled.div`
  top: 50%;
  left: 50%;
  margin-left: -4em;
  margin-top: -4em;
  font-size: 10px;
  border: 0.8em solid rgba(218, 219, 223, 1);
  border-left: 0.8em solid ${({ theme }) => theme.spinner};
  border-radius: 50%;
  width: 8em;
  height: 8em;
  display: block;
  position: absolute;
  animation: spin 1s infinite linear;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;
